module.exports = __webpack_public_path__ + "media/images/riders/JOLANDA_NEFF-9139cc89a41d17ba1839bf861f2a0490.png";